export default __webpack_public_path__ + "static/media/complementary--trailers--g2.bbd07d83.png";